<template>
  <div class="ty-main">
    <div class="ty-content white">
    <el-form :inline="true" :model="form" class="query-form" @submit.native.prevent>
        <el-form-item label="">
          <el-autocomplete
          :placeholder="placeholder"
          v-model="form.searchName"
          :fetch-suggestions="querySearch"
          value-key="name"
          @focus="openSelectDialog"
          @clear="setValueNull"
          @input="inquire"
          @select="handleSelect"
          :trigger-on-focus="false"
          :clearable="clearable"
          class="input-with-select" >
              <el-select v-model="form.select" @change="sdhu" slot="prepend" placeholder="请选择" style="width: 130px;">
                <el-option
                  v-for="item in staff"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  clearable />
              </el-select>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="部门:">
        <el-input
          v-model="form.department_id"
          placeholder="请选择部门"
          @focus="departmentShow2"
          clearable
          @clear="employeeClear"
        ></el-input>
        </el-form-item>
<!--        <el-form-item label="禁用时间:">-->
<!--          <el-date-picker-->
<!--            v-model="form.scopeDate"-->
<!--            type="daterange"-->
<!--            range-separator="至"-->
<!--            start-placeholder="开始日期"-->
<!--            end-placeholder="结束日期"-->
<!--            :picker-options="pickerOptions"-->
<!--            :default-value="Date.now() - 30 * 24 * 3600 * 1000"-->
<!--            >-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button class="dsfdi" type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
          <el-button type="info" plain class="fr" @click="$router.push({
                  path: '/control/regulation'
                })">设置禁用规则</el-button>
      </el-form>
      <el-table :data="tableData" style="width: 100%;" id="table">
        <el-table-column label="员工" fixed width="280">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.staff_data.name.length > 10"
              placement="top-start"
              popper-class="popperBox"
              trigger="hover">
              <span>{{scope.row.staff_data.name}}
                <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
              </span>
              <span slot="reference" style="color: #303133;">{{scope.row.staff_data.name | ellipsis}}
                <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
                <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
                <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
              </span>
            </el-popover>
          <div v-else>
            <span>{{ scope.row.staff_data.name }}</span>
              <span class="tag" v-if="scope.row.new_user_session_status === -1">存档关闭</span>
              <span class="tag01" v-if="scope.row.new_user_session_status === 1">存档</span>
              <span class="tag" v-if="scope.row.new_user_status === -1">离职</span>
          </div>
           <div v-if="scope.row.staff_data.length === 0"><span>未知员工</span></div>
          </template>
        </el-table-column>
        <el-table-column label="部门" min-width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.staff_data.department_name.length > 0">
              <el-popover
                v-if="scope.row.staff_data.department_name.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.staff_data.department_name}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.staff_data.department_name | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.staff_data.department_name}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="企微应用通知人" min-width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.direct_leader.length > 0">
              <el-popover
                v-if="scope.row.direct_leader.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.direct_leader}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.direct_leader | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.direct_leader}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="应用通知状态" min-width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.app_notice_status.length > 0 && scope.row.direct_leader != ''">
              <el-popover
                v-if="scope.row.app_notice_status.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.app_notice_status}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.app_notice_status | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.app_notice_status}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="AD邮件通知人" min-width="400">
          <template slot-scope="scope">
            <div v-if="scope.row.mail_notice_staff.length > 0">
              <el-popover
                v-if="scope.row.mail_notice_staff.length > 40"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.mail_notice_staff}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.mail_notice_staff | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.mail_notice_staff}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="邮件通知状态" min-width="354">
          <template slot-scope="scope">
            <div v-if="scope.row.mail_notice_status.length > 0 && scope.row.mail_notice_staff != ''">
              <el-popover
                v-if="scope.row.mail_notice_status.length > 16"
                placement="top-start"
                popper-class="popperBox"
                trigger="hover">
                <div>{{scope.row.mail_notice_status}}</div>
                <span slot="reference" style="color: #303133;">{{scope.row.mail_notice_status | ellipsiss}}</span>
              </el-popover>
              <span v-else>{{scope.row.mail_notice_status}}</span>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>

<!--        <el-table-column label="禁用时间" min-width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{scope.row.disable_time ? scope.row.disable_time : '-'}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="weewq(scope)"
              >详情</el-button
            >
<!--            <el-button-->
<!--              type="text"-->
<!--              @click="relieve(scope.row)"-->
<!--              >解除禁用</el-button-->
<!--            >-->
          </template>
        </el-table-column>
        <template #empty>
          <el-empty v-loading="loading"></el-empty>
        </template>
      </el-table>
      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              size="small"
              @input="dfhuh"
              @clear="gdfgf"
              clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :check-strictly="true"
              :default-checked-keys="peoples"
              lazy
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img imgleft" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    {{ data.label }}<span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="margin-left: -40px;text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>已选择的员工</div>
             <ul class="infinite-list">
              <li v-for="item in checkedDimission" :key="item.id">
                <img class="organization-img" src="../../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div :class="item.name.length <= 20 ? 'wqeq' : 'gfdgd'">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
               </div>
              </li>
          </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closee">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled01" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择部门 -->
    <el-dialog title="选择部门" :visible.sync="departmentShow" :show-close="false" :close-on-click-modal="false" width="600px">
      <el-row>
        <el-col :span="12" style="border-right: 1px solid rgba(216, 220, 225, 0.39);">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <el-input
              class="filter-input"
              placeholder="搜索部门"
              prefix-icon="el-icon-search"
              v-model="filterTexts"
              size="small"
              clearable
            >
            </el-input>
            <el-tree
              ref="treeDepartment"
              :data="departmentData"
              node-key="value"
              :props="departmentProps"
              :check-on-click-node="true"
              @check-change="getDepart"
              :default-expanded-keys="departs"
              :default-checked-keys="departs"
              :filter-node-method="filterDepart"
              :check-strictly="true"
            >
            <span class="custom-tree-node" slot-scope="{ node }">
              <span>
                <img class="organization-img" src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                {{ node.label }}<span
                      v-if="node.checked"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
              </span>
            </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div class="xuanze">已选择的部门</div>
            <ul class="infinite-list">
              <li class="weqw"
              v-for="item in checkedDepartment"
              :key="item.id">
                <img src="../../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                <div :class="item.label.length <= 20 ? 'wq' : 'wq01'">{{ item.label }}</div>
                <i class="el-icon-close" @click="empClose(item)"></i>
              </li>
            </ul>
          <!--  <el-tag
              v-for="item in checkedDepartment"
              :key="item.value"
              closable
              :disable-transitions="false"
              @close="departClose(item)"
            >
              {{ item.label }}
            </el-tag> -->
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closeDepart">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled2"  @click="reLoadDepart">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    // this.searchIds = []
    return {
      currentPage: 1,
      pagesize: 10,
      placeholder: '请选择在职员工',
      treeData: [],
      treeData01: [],
      treeData02: [],
      loading: false,
      filterText: '',
      filterTexts: '',
      total: 0,
      departmentShow: false,
      departs: [],
      checkedDepartment: [],
      departmentData: [],
      depapart_id: [],
      disabled2: true,
      trigger: true,
      clearable: false,
      departmentProps: {
        children: 'child',
        label: 'label',
        value: 'value'
      },
      r: '',
      arr: [],
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
      },
      tableData: [],
      user_name: '',
      checkedDimission: [],
      isSelectDialog: false,
      isDepartmentDialog: false,
      form: {
        searchName: '',
        department_id: '',
        scopeDate: '',
        searchIds: [],
        select: '1'
      },
      msgId: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      value: '1',
      disabled01: true,
      shdio: '',
      staff: [{
        value: '1',
        label: '在职员工:'
      }, {
        value: '2',
        label: '离职员工:'
      }],
      peoples: []
    }
  },
  mounted() {
    this.getList()
    this.sdhu()
    this.getLeaveStaff()
    this.sfhusi()
    this.getDepartment()
  },
  watch: {
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.parent_id = 0
        this.sfhusi()
      }
    },
    filterTexts(val) {
      if (val) {
        this.$refs.treeDepartment.filter(val)
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    },
    checkedDepartment(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  methods: {
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.chooseNode = 0
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          res.return_data = [{ isDepartment: true }]
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    sdhu(item) {
        if (item === '2') {
          this.placeholder = '请输入离职员工'
          this.form.searchName = ''
          this.form.searchIds = []
        } else {
          this.placeholder = '请选择在职员工'
          this.form.searchName = ''
          this.form.searchIds = []
        }
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    },
    closee() {
      this.isSelectDialog = false
      this.filterText = ''
      this.filterText = ''
      this.peoples = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    gdfgf() {
      this.filterText = ''
      this.treeData01 = []
      // this.sfhusi()
    },
    // 获取离职员工
    getLeaveStaff(name) {
      this.$api
        .get('/api/system/get/quit/staff', {
          name: name
        })
        .then(res => {
          const list = []
          res.forEach(v => {
            list.push({
              name: v.name + '~' + v.department_name
            })
          })
          this.leaveAllList = res
        })
    },
    close() {
      this.isSelectDialog = false
      this.treeData = []
      this.peoples = []
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    reLoadTable() {
      const q = []
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
            q.push(v.name)
            this.form.searchIds.push(v.id)
        })
        this.form.searchName = q.toString()
        this.currentPage = 1
        this.getList()
        this.isSelectDialog = false
      } else {
        this.$message.warning('请选择员工')
      }
    },
    openSelectDialog() {
      this.form.searchName = ''
      this.form.searchIds = []
      if (this.form.select === '1') {
          this.isSelectDialog = true
          this.form.searchName = ''
          this.arr = []
          this.getlistAll()
          this.trigger = false
          this.clearable = true
      } else if (this.form.select === '2') {
        this.user_name = ''
        this.isSelectDialog = false
        this.trigger = true
        this.clearable = false
      }
    },
    clear() {
      //  this.filterText = ''
      //  this.treeData02 = []
      //  this.treeData01 = []
      //  this.checkedDimission = []
       this.parent_id = 0
    },
    weewq(scope) {
      this.$emit('staffId', scope.row.staff_id, 'status', scope.row.staff_data.status)
      this.$emit('status', scope.row.staff_data.status)
      this.$emit('staffName', scope.row.staff_data.name)

      // this.$router.push({
      //               path: '/control/operationLog', query: { staff_id: scope.row.staff_id, status: scope.row.staff_data.status }
      //             })
    },
    relieve(row) {
      this.$confirm('解除禁用后，该员工可以继续删除客户，是否解除？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      }).then(() => {
        this.$api.post('/api/system/sensitive/update/user', {
          staff_id: row.staff_id,
          enable: 1
        })
        .then(res => {
          this.$message({
            type: 'success',
            message: '解除禁用成功!'
          })
          this.getList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解除禁用'
        })
      })
    },
    querySearch(queryString, cb) {
      var restaurants = this.leaveAllList
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      setTimeout(() => {
        cb(results)
      }, 3000)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    inquire() {
      this.queryString = this.form.searchName
      this.querySearch()
    },
    handleSelect(item) {
      this.user_name = item.name
    },
    setValueNull() {
      this.id = []
      this.form.searchIds = []
      this.filterText = ''
      this.treeData01 = []
      this.treeData02 = []
      this.checkedDimission = []
      this.parent_id = 0
      this.sfhusi()
      this.getList()
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    getlistAll() {
      const params = {
        page: 1,
        limit: 15
      }
      this.$api.get('/api/v1/inherit/get-department-user', params).then(response => {
        let res = response
        if (response && typeof response === 'string') {
          res = JSON.parse(response)
        }
        const treeData = res || []
        treeData.forEach(v => {
          v.checkTitle = v.name
          v.id = v.user_id
        })
        this.treeData = treeData || []
      })
    },
    onSearch() {
      this.currentPage = 1
      this.getList()
    },
    getChecked(value, isCheck) {
      if (value.isDepartment === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        this.checkedDimission.forEach(v => {
          this.peoples.push(v.id)
        })
        return false
      }
    },
    getList() {
      this.loading = true
      const { scopeDate } = this.form
      let scopeTime = {}
      if (scopeDate && scopeDate.length) {
        scopeTime = {
          start_time: this.$moment(new Date(scopeDate[0])).format('YYYY-MM-DD 00:00:00'),
          end_time: this.$moment(new Date(scopeDate[1])).format('YYYY-MM-DD 23:59:59')
        }
      }
      this.$api.post('/api/system/sensitive/disabled', {
          page: this.currentPage,
          staff_id: this.form.searchIds,
          user_name: this.user_name,
          department_id: this.depapart_id,
          start_time: scopeTime.start_time,
          end_time: scopeTime.end_time
        })
        .then(res => {
          const tableData = res.data
          this.total = res.total
          this.tableData = tableData
          this.loading = false
        })
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
    },
    openDetailDialog(row) {
        this.$router.push({
          path: '/control/operationLog',
          query: { staff_id: row.staff_id, status: row.staff_data.status }
        })
        // this.$emit('staff_id', this.$refs.row.staff_id)
    },
    departmentShow2() {
      this.depapart_id = []
      this.departmentShow = true
    },
    // 获取部门表
    getDepartment() {
      this.$api.get('/api/v1/inherit/get-department', {
        user_id: sessionStorage.getItem('user_id')
      }).then(response => {
        let arr = []
        arr = response.data
        this.departmentData = arr || []
      })
    },
    empClose(value) {
      this.$refs.treeDepartment.setChecked(value.value, false)
    },
    getDepart(value, isCheck) {
      const checkedDepartment = this.checkedDepartment
      if (isCheck) {
        checkedDepartment.push({
          label: value.label,
          value: value.value
        })
      } else {
        checkedDepartment.forEach((item, i) => {
          if (item.value === value.value) {
            checkedDepartment.splice(i, 1)
          }
        })
      }
      this.checkedDepartment = checkedDepartment
      this.checkedDepartment.forEach(k => {
        this.departs.push(k.id)
      })
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    reLoadDepart() {
      const l = []
      if (this.checkedDepartment.length > 0) {
        this.checkedDepartment.forEach(v => {
          l.push(v.label)
          this.depapart_id.push(v.value)
        })
        this.form.department_id = l.toString()
        this.currentPage = 1
        this.departmentShow = false
        this.getList()
      } else {
        this.$message.warning('请先选择部门')
      }
    },
    closeDepart() {
      this.filterTexts = ''
      this.form.department_id = ''
      this.departmentShow = false
      this.getDepartment()
      // this.departmentData = []
      this.checkedDepartment = []
    },
    filterDepart(value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    employeeClear() {
      this.id = ''
      this.depapart_id = []
      this.filterTexts = ''
      this.getDepartment()
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-card{
  overflow:auto;
  box-shadow: none;
}
::v-deep .el-dialog .el-dialog__footer{
  text-align:right;
}
::v-deep .el-dialog__body{
  padding: 0;
}
.img{
    width:32px;
    height:32px;
    border-radius: 2px;
    border: 1px solid #204A9E;
  }
.zi{
  margin-left: 16px;
  line-height: 35px;

}
.biao{
  margin-left:5px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 35px;
  color: #46BB36;
  opacity: 1;
}
.qian{
  margin-left:5px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 35px;
  color: #FFC811;
  opacity: 1;
}
::v-deep.ty-cont{
  height: auto;
}
::v-deep.el-form-item{
  margin-bottom: 0;
}
::v-deep .el-dialog__header {
    background: #FFFFFF;
    box-shadow: 0px 2px 10px rgb(2 47 50 / 8%);
    opacity: 1;
    border-radius: 2p;
}
::v-deep .el-radio-button__inner{
  border:1px solid #204a9e;
  color:#204a9e;
}
::v-deep .el-select .el-tag__close.el-icon-close{
  display: none;
}
::v-deep .input-with-select .el-input-group__prepend {
    background-color: #fff;
    color: #303133;
    font-size: 16px;
    border: none;
  }
//   ::v-deep .input-with-select .el-input-group__prepend:focus {
//     background-color: #fff;
//   }
//   ::v-deep .input-with-select .el-input-group__prepend:hover {
//     background-color: #fff;
//   }
::v-deep .el-input-group--prepend .el-input__inner:hover{
  border-color: #234C9C;
}
.fr {
  float: right;
  margin-bottom: 20px;
}
::v-deep .el-message-box__content {
  padding: 10px;
}
.el-button--primary.is-disabled{
  opacity: 0.7;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep .el-autocomplete{
  line-height: 40px;
}
::v-deep .el-input-group__prepend{
  padding-left: 5px;
}
</style>
